import imgix from "@lonelyplanet/dotcom-core/dist/helpers/imgix";

export default function poiImages({
  poi,
  mediaParams = {
    auto: "enhance",
    w: 770,
    h: 430,
    fit: "crop",
  },
  provider = "media",
}) {
  if (!poi.imageAssociations) return [];

  if (Array.isArray(poi.imageAssociations)) {
    return poi.imageAssociations.reduce((memo, image) => {
      if (image.from) {
        memo.push({
          src: imgix(image.from.links.pixels, mediaParams, provider),
          provider,
        });
      }

      return memo;
    }, []);
  }

  const url = poi.imageAssociations.from ?
    poi.imageAssociations.from.links.pixels :
    "";

  return url ? [imgix(url, mediaParams, provider)] : [];
}



// WEBPACK FOOTER //
// ./assets/pois/utils/poiImages.js